import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "export-pptist-dialog" }
const _hoisted_2 = { class: "configs" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = ["data-range"]
const _hoisted_6 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, "导出范围：", -1)),
        _createVNode(_component_RadioGroup, {
          class: "config-item",
          value: _ctx.rangeType,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rangeType) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              style: {"width":"33.33%"},
              value: "all"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("全部")
              ])),
              _: 1
            }),
            _createVNode(_component_RadioButton, {
              style: {"width":"33.33%"},
              value: "current"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("当前页")
              ])),
              _: 1
            }),
            _createVNode(_component_RadioButton, {
              style: {"width":"33.33%"},
              value: "custom"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("自定义")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (_ctx.rangeType === 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "title",
              "data-range": `（${_ctx.range[0]} ~ ${_ctx.range[1]}）`
            }, "自定义范围：", 8, _hoisted_5),
            _createVNode(_component_Slider, {
              class: "config-item",
              range: "",
              min: 1,
              max: _ctx.slides.length,
              step: 1,
              value: _ctx.range,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.range) = $event))
            }, null, 8, ["max", "value"])
          ]))
        : _createCommentVNode("", true),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "tip" }, " 提示：.pptist 是本应用的特有文件后缀，支持将该类型的文件导入回应用中。 ", -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Button, {
        class: "btn export",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportSpecificFile(_ctx.selectedSlides)))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("导出 .pptist 文件")
        ])),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn close",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [
          _createTextVNode("关闭")
        ])),
        _: 1
      })
    ])
  ]))
}